export default "__VITE_ASSET__wrx0qQdp__"